import { useState, useRef, useEffect } from 'react';
import { useCurrencyStore, DISPLAY_CURRENCIES } from '../store/currency';

export default function CurrencyToggle() {
  const { currency, setCurrency, rates } = useCurrencyStore();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative', padding: '0 10px', marginBottom: 4 }}>
      <button
        onClick={() => setOpen(o => !o)}
        title="Change display currency"
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '7px 10px',
          background: 'rgba(255,255,255,0.07)',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 7,
          cursor: 'pointer',
          color: 'var(--sidebar-fg, #e2e8f0)',
          fontSize: 12.5,
          fontFamily: 'var(--font-b)',
          fontWeight: 500,
          transition: 'background 0.15s',
        }}
        onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.12)'}
        onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.07)'}
      >
        <span style={{ fontSize: 11, fontWeight: 700, opacity: 0.6, letterSpacing: '0.05em' }}>FX</span>
        <span style={{ flex: 1, textAlign: 'left' }}>{currency}</span>
        <span style={{ fontSize: 9, opacity: 0.5 }}>▾</span>
      </button>

      {open && (
        <div style={{
          position: 'absolute',
          bottom: 'calc(100% + 6px)',
          left: 10,
          right: 10,
          background: '#1e2533',
          border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: 9,
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          zIndex: 500,
          overflow: 'hidden',
        }}>
          <div style={{ padding: '8px 12px 6px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.4)' }}>
            Display Currency
          </div>
          {DISPLAY_CURRENCIES.map(({ code, label }) => {
            const rate = rates?.[code];
            const rateLabel = rate && code !== 'USD' ? `${rate.toLocaleString('en-US', { maximumFractionDigits: 2 })} per $1` : null;
            const isSelected = code === currency;
            return (
              <button
                key={code}
                onClick={() => { setCurrency(code); setOpen(false); }}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '8px 12px',
                  background: isSelected ? 'rgba(255,255,255,0.1)' : 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  color: isSelected ? '#fff' : 'rgba(255,255,255,0.7)',
                  fontSize: 12.5,
                  fontFamily: 'var(--font-b)',
                  textAlign: 'left',
                  transition: 'background 0.1s',
                }}
                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; }}
                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = 'transparent'; }}
              >
                <span style={{ width: 32, fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', letterSpacing: '0.03em', flexShrink: 0 }}>{code}</span>
                <span style={{ flex: 1, fontWeight: isSelected ? 600 : 400, fontSize: 12 }}>{label.split('—')[1]?.trim()}</span>
                {rateLabel && <span style={{ fontSize: 10, opacity: 0.45 }}>{rateLabel}</span>}
                {isSelected && <span style={{ color: '#4ade80', fontSize: 11, marginLeft: 4 }}>&#10003;</span>}
              </button>
            );
          })}
          <div style={{ padding: '6px 12px 8px', fontSize: 10, color: 'rgba(255,255,255,0.3)', borderTop: '1px solid rgba(255,255,255,0.08)', marginTop: 4 }}>
            All amounts stored in USD · converted at live rates
          </div>
        </div>
      )}
    </div>
  );
}
